import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Card.module.css'

interface CardProps {
  children: ReactNode
  className?: string
  /** Removes the inner padding for cards that hold a full-bleed table. */
  flush?: boolean
  as?: 'div' | 'section' | 'article'
}

export function Card({ children, className, flush = false, as: Tag = 'div' }: CardProps) {
  return <Tag className={cn(styles.card, flush && styles.flush, className)}>{children}</Tag>
}

interface CardHeaderProps {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  className?: string
}

export function CardHeader({ title, description, actions, className }: CardHeaderProps) {
  return (
    <div className={cn(styles.header, className)}>
      <div className={styles.headerText}>
        <h2 className={styles.title}>{title}</h2>
        {description ? <p className={styles.description}>{description}</p> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  )
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn(styles.body, className)}>{children}</div>
}

export function CardFooter({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn(styles.footer, className)}>{children}</div>
}
